// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1ltqp","title":"ClientCherryInfo_title__24Le5","itemText":"ClientCherryInfo_itemText__1u2ly"};